module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-container', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "menu-wrapper",
    class: {
      active: _vm.menuVisible
    }
  }, [_c('div', {
    staticClass: "menu-container"
  }, [_c('div', {
    staticClass: "dashboard",
    on: {
      "click": _vm.goToDashboard
    }
  }, [_c('div', {
    staticClass: "dashboard-icon"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/dashboard.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "dashboard-text"
  }, [_vm._v("进入数字版")])]), _vm._v(" "), _c('div', {
    staticClass: "menu-scroll",
    class: {
      active: _vm.menuVisible
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "padding": "5px"
    }
  }, _vm._l((_vm.menus), function(item, index) {
    return (item.enable) ? _c('r-menu-item', {
      key: index,
      attrs: {
        "icon": item.icon,
        "to": item.to,
        "title": item.title
      }
    }) : _vm._e()
  }), 1)]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "menu-switch",
    class: {
      hidden: !_vm.menuVisible
    },
    style: ({
      display: _vm.oss && _vm.$route.name === 'ceBao123' ? 'none' : ''
    }),
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('i', {
    staticClass: "menuicon",
    class: _vm.menuVisible ? 'menuicon-left' : 'menuicon-right'
  })])]), _vm._v(" "), _c('el-main', {
    staticClass: "content-container",
    class: {
      active: _vm.menuVisible
    }
  }, [_c('router-view', {
    staticClass: "right-content-box"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-516defb6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu.vue
// module id = 273
// module chunks = 32